import { Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, Divider, IconButton, MenuItem, TextField } from "@mui/material";
import React, { Component } from "react";
import DialogTitleWithCloseButton from "../../../components/DialogTitleWithCloseButton";
import { errorToast } from '../../../toast';
import { hideLoading, showLoading } from '../../../loading';
import request from '../../../request';
import { returnChangedAttributes } from '../../../utils';
import swal from 'sweetalert';
import LabeledContainer from "../../../components/LabeledContainer";
import CenteredMessage from "../../../components/CenteredMessage";
import RoundedIconButton from "../../../components/RoundedIconButton";
import AddIcon from '@mui/icons-material/Add';
import SearchProduct, { fetchProducts } from "../SearchProduct";
import RefreshIcon from '@mui/icons-material/Refresh';
import { PRODUCT_TYPE } from "../../../../../shared/constants";
import SearchItem from "../../../components/SearchItem";
import ImageIcon from '@mui/icons-material/Image';
import { Delete } from "@mui/icons-material";


export default class Editor extends Component {

   state = {
      name: this.props.productBeingEdited?.name || "",
      description: this.props.productBeingEdited?.description || "",
      type: this.props.productBeingEdited?.type || "",
      installable: this.props.productBeingEdited?.installable || '',
      composition: this.props.productBeingEdited?.composition || [],
      cachedProducts: null,
      fetchingProducts: false,
      connectToNewQuickbooksProduct: false,
      disableConnectToNewQuickbooksProductButton: false,
      quantityOnHand: '',
      purchaseCost: '',
      inventoryStartDate: null,
      selectedQuickbooksProduct: null
   }

   componentDidUpdate(_, prevState) {
      // if in add mode and the product has composition
      // disable the connect to new quickbooks product and
      // set [connectToNewQuickbooksProduct] to false
      // and [disableConnectToNewQuickbooksProductButton] to true
      if (!this.isInEditMode()) {
         if (this.state.composition.length > 0 && prevState.composition.length === 0) {
            this.setState({
               connectToNewQuickbooksProduct: false,
               disableConnectToNewQuickbooksProductButton: true
            });
         } else if (this.state.composition.length === 0 && prevState.composition.length > 0) {
            this.setState({
               disableConnectToNewQuickbooksProductButton: false
            });
         }
      }
   }

   isInEditMode = () => {
      return !!this.props.productBeingEdited;
   }

   submit = async () => {

      // extract data
      const txtName = document.getElementById("txt-name");
      const txtDescription = document.getElementById("txt-description");
      const txtType = document.getElementById("txt-type");
      const chkInstallable = document.getElementById("chk-installable");

      const { name, description, type, installable } = this.state;

      // validate
      if (!name) {
         errorToast("Name is required");
         return txtName.focus();
      }

      if (!description) {
         errorToast("Description is required");
         return txtDescription.focus();
      }

      if (!type) {
         errorToast("Type is required");
         return txtType.focus();
      }

      if (installable === "") {
         errorToast("Installable is required");
         return chkInstallable.focus();
      }

      let composition;

      if (this.state.composition.length > 0) {

         composition = [];

         for (let i = 0; i < this.state.composition.length; i++) {

            const { quantity, product } = this.state.composition[i];

            if (!product) {
               errorToast(`Select product in slot ${i + 1}`);
               return;
            }

            if (!quantity) {
               errorToast(`"${product.name}" quantity is required`);
               return;
            }

            composition.push({
               product: product._id,
               quantity
            });

         }

      }

      if (!this.isInEditMode()) {
         if (this.state.connectToNewQuickbooksProduct) {
            if (this.state.quantityOnHand === '') {
               errorToast("Quantity on hand is required");
               return;
            }

            if (this.state.purchaseCost === '') {
               errorToast("Purchase cost is required");
               return;
            }

            if (!this.state.inventoryStartDate) {
               errorToast("Inventory start date is required");
               return;
            }
         } else {
            if (!this.state.selectedQuickbooksProduct) {
               errorToast("Select Quickbooks product");
               return;
            }
         }
      }

      // send request
      try {

         showLoading();

         let url = "/api/sales/products", method;

         let data = {
            name,
            description,
            type,
            installable,
            composition
         };

         if (this.isInEditMode()) {

            url += `/${this.props.productBeingEdited._id}`;
            method = "PATCH";

            data = returnChangedAttributes(
               data,
               {
                  name: this.props.productBeingEdited.name,
                  description: this.props.productBeingEdited.description,
                  installable: this.props.productBeingEdited.installable,
                  composition: this.props.productBeingEdited.composition.map(p => ({
                     product: p.product._id,
                     quantity: p.quantity
                  }))
               }
            );

            if (Object.keys(data).length === 0) {
               errorToast("No changes made");
               return this.props.onClose();
            }
         } else {
            method = "POST";

            const quickbooks = {}

            if (this.state.connectToNewQuickbooksProduct) {
               quickbooks.quantity_on_hand = this.state.quantityOnHand;
               quickbooks.inventory_start_date = this.state.inventoryStartDate;
               quickbooks.purchase_cost = this.state.purchaseCost;
            } else {
               quickbooks.id = this.state.selectedQuickbooksProduct.id;
            }

            data.quickbooks = quickbooks;
         }

         const res = await request({ url, method, data });
         this.props.onClose(res.data);

      } catch (err) {
         swal("Error", err.message, "error");
      } finally {
         hideLoading();
      }
   }

   render() {

      let composition;

      if (this.state.composition.length === 0) {
         composition = <div className="h-[150px]">
            <CenteredMessage message="No products"  />
         </div>
      } else {

         composition = <div className="grid grid-cols-[1fr,auto,auto] gap-x-2 gap-y-4 mt-4">
            {
               this.state.composition.map(item => <>
                  <div>
                     <SearchProduct
                        label="Select Product"
                        size="small"
                        cachedData={this.state.cachedProducts}
                        onDataFetched={data => this.setState({ cachedProducts: data })}
                        onChange= {
                           product => {
                              const composition = this.state.composition.map(p => {
                                 if (p === item)
                                    return { ...item, product };
                                 return p;
                              });

                              this.setState({ composition });
                           }
                        }
                        value={item.product}
                        hideRefreshButton
                     />
                  </div>
                  <input
                     type="number"
                     style={{
                        fieldSizing: 'content',
                     }}
                     className="border border-gray-300 px-2 py-1 rounded [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                     placeholder="Qty"
                     value={item.quantity}
                     onChange={e => {
                        const composition = this.state.composition.map(p => {
                           if (p === item)
                              return { ...item, quantity: e.target.value };
                           return p;
                        });

                        this.setState({ composition });
                     }}
                  />
                  <IconButton
                     size="small"
                     onClick={() => {
                        const composition = this.state.composition.filter(p => p !== item);
                        this.setState({ composition });
                     }}
                     color="error"
                  >
                     <Delete />
                  </IconButton>
               </>)
            }
         </div>
      }

      return <Dialog open fullWidth maxWidth="sm">
         <DialogTitleWithCloseButton onClose={this.props.onClose}>
            {this.isInEditMode() ? "Edit" : "Add"} Product
         </DialogTitleWithCloseButton>
         <DialogContent dividers>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-2">
               <TextField
                  id="txt-name"
                  label="Name"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={this.state.name}
                  onChange={e => this.setState({ name: e.target.value })}
               />
               <TextField
                  id="txt-description"
                  label="Description"
                  variant="outlined"
                  size="small"
                  fullWidth
                  multiline
                  value={this.state.description}
                  onChange={e => this.setState({ description: e.target.value })}
               />

               <TextField
                  id="txt-type"
                  label="Type"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={this.state.type}
                  onChange={e => this.setState({ type: e.target.value })}
                  select
               >
                  {
                     Object
                        .values(PRODUCT_TYPE)
                        .map(type => <MenuItem key={type} value={type}>
                           {type.toUpperCase()}
                        </MenuItem>)
                  }
               </TextField>

               <div className="flex items-center">
                  <Checkbox
                     id="chk-installable"
                     type="checkbox"
                     checked={this.state.installable}
                     indeterminate={this.state.installable === ""}
                     onChange={e => this.setState({ installable: e.target.checked })}
                  />
                  <label htmlFor="chk-installable" className="text-gray-600">Installable</label>
               </div>

               <LabeledContainer label="Composition" className="col-span-full p-0 rounded">
                  <div className="grid grid-rows-[1fr,auto]">
                     <div className="overflow-y-auto p-2">
                        {composition}
                     </div>
                     <div className="flex justify-end">

                        {
                           this.state.composition.length > 0 && <RoundedIconButton
                              onClick={() => {

                                 this.setState({ fetchingProducts: true });

                                 fetchProducts()
                                    .then(cachedProducts => this.setState({ cachedProducts }))
                                    .catch(err => swal("Error", err.message, "error"))
                                    .finally(() => this.setState({ fetchingProducts: false }))
                                                               
                              }}
                              disabled={this.state.fetchingProducts}
                           >
                              {
                                 this.state.fetchingProducts ?
                                    <CircularProgress size={20} thickness={6} /> : <RefreshIcon fontSize="small" />
                              }
                           </RoundedIconButton>
                        }

                        <RoundedIconButton
                           onClick={() => this.setState({ composition: [ ...this.state.composition, {}  ] })}
                           color="primary"
                           size="small"
                        >
                           <AddIcon fontSize="small" />
                        </RoundedIconButton>
                     </div>
                  </div>
               </LabeledContainer>

               {
                  !this.isInEditMode() && <div className="col-span-full flex flex-col gap-2">
                     <Divider />
                     <div className="flex items-center">
                        <Checkbox
                           size="small"
                           checked={this.state.connectToNewQuickbooksProduct}
                           onChange={e => this.setState({ connectToNewQuickbooksProduct: e.target.checked })}
                           disabled={this.state.disableConnectToNewQuickbooksProductButton}
                        />
                        <span className={`text-gray-600 ${this.state.disableConnectToNewQuickbooksProductButton ? 'opacity-50' : ''}`}>
                           Connect to new Quickbooks product
                        </span>
                     </div>
                     {
                        !this.state.connectToNewQuickbooksProduct && <div className="flex items-center gap-2">
                           <SearchItem
                              fetchData={async () => {
                                 const res = await request.get('/api/general/quickbooks/products');
                                 return res.data.products;
                              }}
                              renderOption={(props, product) => <li {...props}>
                                 <div className="flex items-center text-gray-400 text-4xl">
                                    <ImageIcon fontSize="inherit" />
                                 </div>
                                 <div className="flex flex-col justify-center text-sm overflow-hidden">
                                    <div className="font-bold">
                                       {product.name}
                                    </div>
                                    <div className="text-gray-500 truncate text-xs">
                                       {product.description}
                                    </div>
                                 </div>
                              </li>}
                              transformOption={option => ({ ...option, label: option.name })}
                              value={this.state.selectedQuickbooksProduct}
                              onChange={selectedQuickbooksProduct => this.setState({ selectedQuickbooksProduct })}
                              size="small"
                              label="Select Quickbooks product"
                              className="w-full"
                           />
                        </div>
                     }
                     {
                        this.state.connectToNewQuickbooksProduct && <div className="grid grid-cols-2 gap-6">
                           <TextField
                              label="Quantity on hand"
                              type="number"
                              size="small"
                              value={this.state.quantityOnHand}
                              onChange={e => this.setState({ quantityOnHand: e.target.value })}
                           />
                           <TextField
                              label="Purchase cost"
                              type="number"
                              size="small"
                              value={this.state.purchaseCost}
                              onChange={e => this.setState({ purchaseCost: e.target.value })}
                           />
                           <TextField
                              label="Inventory start date"
                              type="date"
                              size="small"
                              value={this.state.inventoryStartDate}
                              onChange={e => this.setState({ inventoryStartDate: e.target.value })}
                              slotProps={{
                                 inputLabel: {
                                    shrink: true,
                                 },
                              }}
                           />
                        </div>
                     }
                  </div>
               }
            </div>
         </DialogContent>
         <DialogActions>
            <Button variant="contained" onClick={this.submit}>
               {this.isInEditMode() ? "Update" : "Add"}
            </Button>
         </DialogActions>
      </Dialog>
   }
}